import React from 'react';
import { Handle, Position } from 'reactflow';

const TurboNode = ({ data, isConnectable }) => {
  const subline = data.Title !== undefined ? data.Title : '';
  return (
    <div className="wrapper gradient">
      <div className="inner">
        <div className="body">
          <div>
            <div className="title">{data.label}</div>
            {subline && <div className="subline">{subline}</div>}
          </div>
        </div>
        <Handle type="target" position={Position.Left} isConnectable={isConnectable} />
        <Handle type="source" position={Position.Right} isConnectable={isConnectable} />
      </div>
    </div>
  );
};

export default TurboNode;

